export default "__VITE_ASSET__93afbe78__"